module.exports = __webpack_public_path__ + "static/media/PlusOutlined.6a77bd43.svg";